import { useState, useEffect } from 'react';
import { getUsers } from '../services/api';

let cacheUsuarios = null;

const carregarUsuarios = () => {
    if (!cacheUsuarios) {
        cacheUsuarios = getUsers().then((resposta) => {
            const lista = Array.isArray(resposta?.data) ? resposta.data : [];
            if (lista.length === 0) {
                cacheUsuarios = null;
            }
            return lista;
        });
    }
    return cacheUsuarios;
};

// Usuario bloqueado nao aparece para escolha (#2611). manterId preserva o valor ja
// salvo num formulario em edicao, para o select nao ficar vazio.
export const semBloqueados = (lista, manterId = null) =>
    lista.filter((u) => !u.bloqueado || (manterId != null && String(u.id) === String(manterId)));

export const useUsuarios = () => {
    const [usuarios, setUsuarios] = useState([]);

    useEffect(() => {
        let ativo = true;

        carregarUsuarios().then((lista) => {
            if (ativo) {
                setUsuarios(lista);
            }
        });

        return () => {
            ativo = false;
        };
    }, []);

    return usuarios;
};
